import * as tslib_1 from "tslib";
import { memoizeRendering, View } from '@fullcalendar/core';
import TimeAxis from './TimeAxis';
import TimelineLane from './TimelineLane';
var TimelineView = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSkeleton = memoizeRendering(_this._renderSkeleton, _this._unrenderSkeleton);
        _this.startInteractive = memoizeRendering(_this._startInteractive, _this._stopInteractive);
        return _this;
    }
    TimelineView.prototype._startInteractive = function (timeAxisEl) {
        this.context.calendar.registerInteractiveComponent(this, {
            el: timeAxisEl
        });
    };
    TimelineView.prototype._stopInteractive = function () {
        this.context.calendar.unregisterInteractiveComponent(this);
    };
    TimelineView.prototype.render = function (props, context) {
        _super.prototype.render.call(this, props, context); // flags for updateSize, addScroll. and _renderSkeleton/_unrenderSkeleton
        this.renderSkeleton(this.context);
        this.timeAxis.receiveProps({
            dateProfileGenerator: props.dateProfileGenerator,
            dateProfile: props.dateProfile
        }, context);
        this.startInteractive(this.timeAxis.slats.el);
        this.lane.receiveProps(tslib_1.__assign({}, props, { nextDayThreshold: this.context.nextDayThreshold }), context);
        this.startNowIndicator(props.dateProfile, props.dateProfileGenerator);
    };
    TimelineView.prototype.destroy = function () {
        this.startInteractive.unrender(); // "unrender" a weird name
        this.renderSkeleton.unrender();
        _super.prototype.destroy.call(this);
    };
    TimelineView.prototype._renderSkeleton = function (context) {
        this.el.classList.add('fc-timeline');
        if (context.options.eventOverlap === false) {
            this.el.classList.add('fc-no-overlap');
        }
        this.el.innerHTML = this.renderSkeletonHtml();
        this.timeAxis = new TimeAxis(this.el.querySelector('thead .fc-time-area'), this.el.querySelector('tbody .fc-time-area'));
        this.lane = new TimelineLane(this.timeAxis.layout.bodyScroller.enhancedScroll.canvas.contentEl, this.timeAxis.layout.bodyScroller.enhancedScroll.canvas.bgEl, this.timeAxis);
    };
    TimelineView.prototype._unrenderSkeleton = function () {
        this.el.classList.remove('fc-timeline');
        this.el.classList.remove('fc-no-overlap');
        this.timeAxis.destroy();
        this.lane.destroy();
    };
    TimelineView.prototype.renderSkeletonHtml = function () {
        var theme = this.context.theme;
        return "<table class=\"" + theme.getClass('tableGrid') + "\"> <thead class=\"fc-head\"> <tr> <td class=\"fc-time-area " + theme.getClass('widgetHeader') + "\"></td> </tr> </thead> <tbody class=\"fc-body\"> <tr> <td class=\"fc-time-area " + theme.getClass('widgetContent') + "\"></td> </tr> </tbody> </table>";
    };
    TimelineView.prototype.updateSize = function (isResize, totalHeight, isAuto) {
        this.timeAxis.updateSize(isResize, totalHeight, isAuto);
        this.lane.updateSize(isResize);
    };
    // Now Indicator
    // ------------------------------------------------------------------------------------------
    TimelineView.prototype.getNowIndicatorUnit = function (dateProfile, dateProfileGenerator) {
        return this.timeAxis.getNowIndicatorUnit(dateProfile, dateProfileGenerator);
    };
    TimelineView.prototype.renderNowIndicator = function (date) {
        this.timeAxis.renderNowIndicator(date);
    };
    TimelineView.prototype.unrenderNowIndicator = function () {
        this.timeAxis.unrenderNowIndicator();
    };
    // Scroll System
    // ------------------------------------------------------------------------------------------
    TimelineView.prototype.computeDateScroll = function (duration) {
        return this.timeAxis.computeDateScroll(duration);
    };
    TimelineView.prototype.applyScroll = function (scroll, isResize) {
        _super.prototype.applyScroll.call(this, scroll, isResize); // will call applyDateScroll
        var calendar = this.context.calendar;
        // avoid updating stickyscroll too often
        // TODO: repeat code as ResourceTimelineView::updateSize
        if (isResize || calendar.isViewUpdated || calendar.isDatesUpdated || calendar.isEventsUpdated) {
            this.timeAxis.updateStickyScrollers();
        }
    };
    TimelineView.prototype.applyDateScroll = function (scroll) {
        this.timeAxis.applyDateScroll(scroll);
    };
    TimelineView.prototype.queryScroll = function () {
        var enhancedScroll = this.timeAxis.layout.bodyScroller.enhancedScroll;
        return {
            top: enhancedScroll.getScrollTop(),
            left: enhancedScroll.getScrollLeft()
        };
    };
    // Hit System
    // ------------------------------------------------------------------------------------------
    TimelineView.prototype.buildPositionCaches = function () {
        this.timeAxis.slats.updateSize();
    };
    TimelineView.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
        var slatHit = this.timeAxis.slats.positionToHit(positionLeft);
        if (slatHit) {
            return {
                component: this,
                dateSpan: slatHit.dateSpan,
                rect: {
                    left: slatHit.left,
                    right: slatHit.right,
                    top: 0,
                    bottom: elHeight
                },
                dayEl: slatHit.dayEl,
                layer: 0
            };
        }
    };
    return TimelineView;
}(View));
export default TimelineView;
